/**
 * Front-end behaviour for the Portfolio block:
 *  - category tabs filter the grid via AJAX (progressive enhancement — the
 *    first page renders server-side so it works without JS),
 *  - a "Load more" button appends the next page of the current category,
 *  - the grid / list buttons toggle the layout (pure CSS class swap).
 */
( function () {
	function initSection( grid ) {
		const section = grid.closest( '.rm-portfolio' );
		if ( ! section ) {
			return;
		}

		let config;
		try {
			config = JSON.parse( grid.dataset.portfolio || '{}' );
		} catch ( e ) {
			return;
		}

		const tabs = Array.prototype.slice.call(
			section.querySelectorAll( '.rm-portfolio__tab' )
		);
		const views = Array.prototype.slice.call(
			section.querySelectorAll( '.rm-portfolio__view' )
		);
		const moreWrap = section.querySelector( '.rm-portfolio__more' );
		const moreBtn = section.querySelector( '.rm-portfolio__loadmore' );
		const moreLabel = moreBtn
			? moreBtn.querySelector( '.rm-portfolio__loadmore-label' )
			: null;
		const moreDefault = moreLabel ? moreLabel.textContent : '';

		let currentCat = '0';
		let currentPage = 1;
		let maxPages = moreBtn ? parseInt( moreBtn.dataset.max, 10 ) || 1 : 1;
		let busy = false;

		function showMore() {
			if ( moreWrap ) {
				moreWrap.hidden = currentPage >= maxPages;
			}
		}

		function request( page ) {
			const body = new URLSearchParams();
			body.append( 'action', 'rolmmobau_projekt_filter' );
			body.append( 'nonce', config.nonce );
			body.append( 'cat', String( currentCat ) );
			body.append( 'page', String( page ) );
			body.append( 'postsPerPage', String( config.postsPerPage ) );
			body.append( 'orderBy', config.orderBy );
			body.append( 'order', config.order );

			return fetch( config.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: body.toString(),
			} ).then( function ( r ) {
				return r.json();
			} );
		}

		/* ---- View toggle (grid / list) ---- */
		views.forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				const view = btn.dataset.view === 'list' ? 'list' : 'grid';
				views.forEach( function ( b ) {
					b.classList.toggle( 'is-active', b === btn );
					b.setAttribute( 'aria-pressed', b === btn ? 'true' : 'false' );
				} );
				grid.classList.toggle( 'rm-portfolio--list', view === 'list' );
				grid.classList.toggle( 'rm-portfolio--grid', view === 'grid' );
			} );
		} );

		/* ---- Category tabs (AJAX, replace) ---- */
		tabs.forEach( function ( tab ) {
			tab.addEventListener( 'click', function () {
				if ( busy || tab.classList.contains( 'is-active' ) ) {
					return;
				}
				busy = true;
				section.classList.add( 'is-loading' );

				tabs.forEach( function ( t ) {
					t.classList.toggle( 'is-active', t === tab );
					t.setAttribute( 'aria-selected', t === tab ? 'true' : 'false' );
				} );

				currentCat = tab.dataset.cat || '0';
				currentPage = 1;

				request( 1 )
					.then( function ( res ) {
						if ( ! res || ! res.success ) {
							throw new Error( 'bad response' );
						}
						grid.innerHTML = res.data.html || '';
						maxPages = res.data.maxPages || 1;
						if ( moreBtn ) {
							moreBtn.dataset.page = '1';
						}
						showMore();
					} )
					.catch( function () {} )
					.finally( function () {
						busy = false;
						section.classList.remove( 'is-loading' );
					} );
			} );
		} );

		/* ---- Load more (AJAX, append) ---- */
		if ( moreBtn ) {
			moreBtn.addEventListener( 'click', function () {
				if ( busy || currentPage >= maxPages ) {
					return;
				}
				busy = true;
				moreBtn.classList.add( 'is-loading' );
				if ( moreLabel ) {
					moreLabel.textContent = 'Loading…';
				}
				const next = currentPage + 1;

				request( next )
					.then( function ( res ) {
						if ( ! res || ! res.success ) {
							throw new Error( 'bad response' );
						}
						const temp = document.createElement( 'div' );
						temp.innerHTML = res.data.html || '';
						Array.prototype.slice
							.call( temp.children )
							.forEach( function ( child ) {
								grid.appendChild( child );
							} );
						currentPage = next;
						maxPages = res.data.maxPages || maxPages;
						showMore();
					} )
					.catch( function () {} )
					.finally( function () {
						busy = false;
						moreBtn.classList.remove( 'is-loading' );
						if ( moreLabel ) {
							moreLabel.textContent = moreDefault;
						}
					} );
			} );
		}

		/* ---- First-card preview (load-time only) ---- */
		/* Show the first card in its hover state on page load, as a hint. It is
		   cleared the instant the visitor hovers a *different* card and never comes
		   back — hovering the first card itself is ignored (its real :hover already
		   shows the same thing). */
		const firstCard = grid.querySelector( '.rm-portfolio__card' );
		if ( firstCard ) {
			firstCard.classList.add( 'is-preview' );
			const clearPreview = function ( e ) {
				const card = e.target.closest
					? e.target.closest( '.rm-portfolio__card' )
					: null;
				if ( ! card || card === firstCard ) {
					return;
				}
				firstCard.classList.remove( 'is-preview' );
				grid.removeEventListener( 'mouseover', clearPreview );
			};
			grid.addEventListener( 'mouseover', clearPreview );
		}
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		document
			.querySelectorAll( '.rm-portfolio__grid[data-portfolio]' )
			.forEach( initSection );
	} );
} )();
